<app-nav></app-nav>
<app-order-list [orders]="orders"></app-order-list>

<router-outlet></router-outlet>
